import { useState, useEffect, useContext, useRef } from "react";
import { Strings } from "../../../assets/res/en";
import {
  groupsEndPoints,
  merchantsEndPoints,
  cardholdersEndPoints,
} from "../../../utils/endpoints";
import { Context } from "../../../utils/context";
import { modules } from "../../../utils/config";

let searchType = "";
let DOBState = true;

function useMiniCMSCardholders() {
  const { axios, authData, permissions } = useContext(Context);
  const authToken = `Bearer ${authData.token}`;
  const tableRef = useRef();
  const [cardHolderPermission, setCardHolderPermission] = useState({});
  const [filters, setFilters] = useState([]);
  const [groupsMenus, setGroupMenus] = useState([]);
  const [locationMenus, setLocationMenus] = useState([]);
  const [searchData, setSearchData] = useState({
    sCardPhoneLastName: "",
    sDOB: null,
    sGroup: window.MASTER_CMS_GROUP_ID,
    sLocation: window.MASTER_CMS_MERCHANT_ID,
  });

  //console.log(groupsMenus, locationMenus)
  //Enable fisrt automatically search
  useEffect(() => {
   if(searchData.sGroup && searchData.sLocation && tableRef.current){
      //console.log('Disparar busqueda',groupsMenus, searchData.sGroup)
      //console.log(searchData.sGroup, groupsMenus)
     // console.log(searchData.sLocation, locationMenus)
      const validGroup = groupsMenus.find(el => el.val == searchData.sGroup)
      const validLocation = locationMenus.find(el => el.val == searchData.sLocation)
      console.log(validGroup, validLocation)
      if(validGroup && validLocation){
        //console.log('Disparar busqueda')

        //console.log(searchData.sGroup, groupsMenus)
        //console.log(searchData.sLocation, locationMenus)
        handleSearch()
      }
      //const validGroup = gro
      //handleSearch()
    }
  },[searchData.sGroup, searchData.sLocation, groupsMenus, locationMenus])


  //check permission changes
  useEffect(() => {
    if (permissions && permissions.length > 0) {
      let chPermission = permissions.find(
        (p) => p.moduleId === modules.cardholders.id
      );
      setCardHolderPermission(chPermission);
    }
  }, [permissions]);
  //get Groups
  useEffect(() => {
    axios
      .get(groupsEndPoints.getAll, { headers: { Authorization: authToken } })
      .then((res) => {
        if (res.data.success) {
          const { data } = res.data;
          const groupItems = data
            .map((g) => ({
              text: g.description,
              val: g.idGroup,
            }))
            .sort((a, b) => (a.text ?? "").localeCompare(b.text ?? ""));
          setGroupMenus([
            {
              text: Strings.SEARCH_CASINO_GROUP,
              val: "",
            },
            {
              text: Strings.NO_GROUP,
              val: 0,
            },
            ...groupItems,
          ]);
        }
      })
      .catch((err) => err);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  //get Locations On Group Chnage
  useEffect(() => {
    setLocationMenus([
      {
        text: Strings.SEARCH_CASINO_LOCATION,
        val: "",
      },
      {
        text: Strings.NO_LOCATION,
        val: 0,
      },
    ]);
    setSearchData((prevData) => ({
      ...prevData,
      sLocation: window.MASTER_CMS_MERCHANT_ID,
    }));
    if (searchData.sGroup > 0) {
      let merchantByGroupId = `${merchantsEndPoints.getMerchantByGroupID}/${searchData.sGroup}`;
      axios
        .get(merchantByGroupId, { headers: { Authorization: authToken } })
        .then((res) => {
          if (res.status === 200) {
            const { data } = res.data;
            const locationItems = data
              .map((g) => ({
                text: g.description,
                val: g.idMerchant,
                gpo: g.idGroup
              }))
              .sort((a, b) => (a.text ?? "").localeCompare(b.text ?? ""));
            setLocationMenus((prevData) => [...prevData, ...locationItems]);
          }
        })
        .catch((err) => err);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchData.sGroup]);

  const getAllCardholders = (query) =>
    new Promise((resolve, reject) => {
      let order = query.orderDirection === "desc" ? 1 : 0;
      let orderBy = "";
      if (typeof query.orderBy !== "undefined") {
        const { field } = query.orderBy;
        switch (field) {
          case "firstName":
            orderBy = Strings.CARD_ORDERBY_FIRSTNAME;
            break;
          case "groupDescription":
            orderBy = Strings.CARD_ORDERBY_GROUPDESCRIPTION;
            break;
          case "dateOfBirth":
            orderBy = Strings.CARD_ORDERBY_DATEOFBIRTH;
            break;
          case "phoneNumber":
            orderBy = Strings.CARD_ORDERBY_PHONENUMBER;
            break;
          case "merchant":
            orderBy = Strings.CARD_ORDERBY_MERCHANT;
            break;
        }
      }
      let params = {
        Offset: query.page === 0 ? query.page : query.page * query.pageSize,
        Limit: query.pageSize,
        IdGroup: query.IdGroup ?? 0,
        IdMerchant: query.IdMerchant ?? 0,
        PhoneNumber: query.PhoneNumber,
        DateOfBirth: query.DateOfBirth,
        FirstName: query.FirstName,
        LastName: query.LastName,
        OrderBy: orderBy,
        Order: order,
      };
      axios
        .get(cardholdersEndPoints.getAll, {
          headers: { Authorization: authToken },
          params: params,
        })
        .then((res) => {
          if (res.data.success) {
            const { data, counts } = res.data.data;
            resolve({
              data: data,
              page: query.page,
              totalCount: counts,
            });
          }
        });
    });
  const handleChange = (name, value) => {
    const Regex = /[a-zA-Z]/g;
    if (name === "sCardPhoneLastName") {
      DOBState = !Regex.test(value);
      setSearchData((prevData) => ({
        ...prevData,
        [name]: value,
        sDOB: null,
      }));
    } else {
      setSearchData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };
  const handleSearch = () => {
    setFilters([
      {
        name: "sCardPhoneLastName",
        value: searchData["sCardPhoneLastName"],
        remove: clearFilter,
      },
      {
        name: "sDOB",
        value: searchData["sDOB"]?.toLocaleDateString() ?? "",
        remove: clearFilter,
      },
      {
        name: "sGroup",
        value:
          searchData["sGroup"] === ""
            ? ""
            : groupsMenus.find((g) => g.val === searchData["sGroup"]).text,
        remove: clearFilter,
      },
      {
        name: "sLocation",
        value:
          searchData["sLocation"] === ""
            ? ""
            : locationMenus.find((l) => l.val === searchData["sLocation"]).text,
        remove: clearFilter,
      },
      /*{
        name: "clear",
        isClearAll: true,
        clearAll: resetFilterData,
      },*/
    ]);
    const Regex = /[a-zA-Z]/g;
    if (Regex.test(searchData.sCardPhoneLastName)) {
      searchType = "LastName";
    } else {
      searchType =
        searchData.sCardPhoneLastName?.length <= 13
          ? "PhoneNumber"
          : "CardNumber";
    }
    let params = {
      IdGroup: searchData["sGroup"] === "" ? 0 : searchData["sGroup"],
      IdMerchant: searchData["sLocation"] === "" ? 0 : searchData["sLocation"],
      PhoneNumber:
        searchType === "PhoneNumber" ? searchData["sCardPhoneLastName"] : "",
      DateOfBirth:
        searchType === "LastName" && searchData["sDOB"]?.toLocaleDateString()
          ? searchData["sDOB"]?.toLocaleDateString()
          : null,
      FirstName: "",
      LastName: searchType === "LastName" ? searchData.sCardPhoneLastName : "",
    };
    tableRef.current?.onQueryChange(params);
  };

  const clearFilter = ({ name }, nfilters, searchData) => {
    let params = {
      IdGroup: 0,
      IdMerchant: 0,
      PhoneNumber: "",
      DateOfBirth: "",
      FirstName: "",
      LastName: "",
    };
    //#region filter data
    switch (name) {
      case "sCardPhoneLastName":
        if (searchData["sGroup"] !== "" && searchData["sGroup"] >= 0)
          params.IdGroup =
            searchData["sGroup"] === "" ? 0 : searchData["sGroup"];
        if (searchData["sLocation"] !== "" && searchData["sLocation"] >= 0)
          params.IdMerchant =
            searchData["sLocation"] === "" ? 0 : searchData["sLocation"];
        const filnr = nfilters.filter(
          (f) => f.name !== "sCardPhoneLastName" || f.name !== "sDOB"
        );
        const filr = nfilters.find((f) => f.name === "sDOB");
        filr.value = "";
        setFilters([filr, ...filnr]);
        setSearchData((prevData) => ({
          ...prevData,
          sDOB: null,
        }));
        break;
      case "sDOB":
        if (searchData["sCardPhoneLastName"] !== "")
          params.LastName = searchData["sCardPhoneLastName"];
        if (searchData["sGroup"] !== "" && searchData["sGroup"] >= 0)
          params.IdGroup =
            searchData["sGroup"] === "" ? 0 : searchData["sGroup"];
        if (searchData["sLocation"] !== "" && searchData["sLocation"] >= 0)
          params.IdMerchant =
            searchData["sLocation"] === "" ? 0 : searchData["sLocation"];
        break;
      case "sGroup":
        if (searchData["sCardPhoneLastName"] !== "") {
          const Regex = /[a-zA-Z]/g;
          if (Regex.test(searchData["sCardPhoneLastName"])) {
            searchType = "LastName";
          } else {
            searchType =
              searchData.sCardPhoneLastName?.length <= 13
                ? "PhoneNumber"
                : "CardNumber";
          }
          params.PhoneNumber =
            searchType === "PhoneNumber"
              ? searchData["sCardPhoneLastName"]
              : "";
          params.DateOfBirth =
            searchType === "LastName" &&
            searchData["sDOB"]?.toLocaleDateString()
              ? searchData["sDOB"]?.toLocaleDateString()
              : null;
          params.LastName =
            searchType === "LastName" ? searchData["sCardPhoneLastName"] : "";
        }
        const finr = nfilters.filter(
          (f) => f.name !== "sGroup" || f.name !== "sLocation"
        );
        const fir = nfilters.find((f) => f.name === "sLocation");
        fir.value = "";
        setFilters([fir, ...finr]);
        setSearchData((prevData) => ({
          ...prevData,
          sLocation: "",
        }));
        break;
      case "sLocation":
        if (searchData["sCardPhoneLastName"] !== "") {
          const Regex = /[a-zA-Z]/g;
          if (Regex.test(searchData["sCardPhoneLastName"])) {
            searchType = "LastName";
          } else {
            searchType =
              searchData.sCardPhoneLastName?.length <= 13
                ? "PhoneNumber"
                : "CardNumber";
          }
          params.PhoneNumber =
            searchType === "PhoneNumber"
              ? searchData["sCardPhoneLastName"]
              : "";
          params.DateOfBirth =
            searchType === "LastName" &&
            searchData["sDOB"]?.toLocaleDateString()
              ? searchData["sDOB"]?.toLocaleDateString()
              : null;
          params.LastName =
            searchType === "LastName" ? searchData["sCardPhoneLastName"] : "";
        }
        if (searchData["sGroup"] !== "" && searchData["sGroup"] >= 0)
          params.IdGroup =
            searchData["sGroup"] === "" ? 0 : searchData["sGroup"];
        break;
      default:
        break;
    }
    //#endregion

    //#region clear filter
    const filterItemNotToRemove = nfilters.filter((f) => f.name !== name);
    const filterItemToRemove = nfilters.find((f) => f.name === name);
    filterItemToRemove.value = "";
    setFilters([filterItemToRemove, ...filterItemNotToRemove]);
    //#endregion

    setSearchData((prevData) => ({
      ...prevData,
      [name]: name === "sDOB" ? null : "",
    }));
    tableRef.current?.onQueryChange(params);
  };
  const resetFilterData = (nfilters) => {
    setFilters(nfilters.map((item) => ({ ...item, value: "" })));
    setSearchData({
      sCardPhoneLastName: "",
      //sGroup: "",
      //sLocation: "",
      sDOB: null,
    });
    let params = {
      IdGroup: window.MASTER_CMS_GROUP_ID,
      IdMerchant: window.MASTER_CMS_MERCHANT_ID,
      PhoneNumber: "",
      DateOfBirth: "",
      FirstName: "",
      LastName: "",
    };
    tableRef.current?.onQueryChange(params);
  };
  const searchOptions = {
    title: 'Search Cardholder Mini CMS',
    spacing: 2,
    searchItems: [
      {
        name: "sCardPhoneLastName",
        label: Strings.CARD_NUMBER_LABEL,
        defaultValue: searchData["sCardPhoneLastName"],
        onChange: handleChange,
      },
      {
        name: "sDOB",
        label: Strings.DATEOFBIRTH,
        type: "date",
        isDisable: DOBState,
        onChange: handleChange,
        defaultValue: DOBState ? null : searchData["sDOB"],
      },

      {
        name: "sGroup",
        label: Strings.SEARCH_CASINO_GROUP,
        isSelect: true,
        menuItems: groupsMenus,
        defaultValue: searchData["sGroup"],
        onChange: handleChange,
        isDisable:true
      },
      {
        name: "sLocation",
        label: Strings.SEARCH_CASINO_LOCATION,
        isSelect: true,
        menuItems: locationMenus,
        defaultValue: searchData["sLocation"],
        onChange: handleChange,
        isDisable:true
      },
    ],
    handleSearch,
  };
  return {
    filters,
    searchData,
    getAllCardholders,
    searchOptions,
    tableRef,
    cardHolderPermission,
  };
}

export default useMiniCMSCardholders;
